export default __webpack_public_path__ + "static/media/IMPRESION3D2.6920799e.webp";